export default __webpack_public_path__ + "static/media/080_finish_bad.hevc.3f2f6366.mp4";